module.exports = __webpack_public_path__ + "img/左对齐.b1519775.svg";